import {cancelButton} from '../../app-components/action/CloseAction';
import {save} from '../../app-components/action/SaveAction';
import specialityform from './specialityform';

let header = {
  title: 'Add Speciality',
  actions: [cancelButton(), save()],
};

export default specialityform({header});
